"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useContext, useState } from "react";
import SSRIcon from "@ingka/ssr-icon";
import chevronDownSmall from "@ingka/ssr-icon/paths/chevron-down-small";
import Label from "@ingka/label";
import cx from "classnames";
import { FormFieldContext } from "@ingka/form-field";
import ValidationBorder from "@ingka/validation-border";
const Select = (props) => {
  const {
    describedById,
    onChange,
    className,
    prefix = "",
    hintText = "Choose an option",
    id,
    label,
    ssrIcon,
    req,
    value,
    children,
    required,
    disabled = false,
    ...other
  } = props;
  const { shouldValidate, valid } = useContext(FormFieldContext);
  const [withHint, setWithHint] = useState(false);
  const selectRef = useRef(null);
  const hintOptionRef = useRef(null);
  const handleOnChange = (e) => {
    if (onChange) {
      onChange(
        e,
        Boolean(hintOptionRef.current && hintOptionRef.current.selected)
      );
    }
  };
  useEffect(() => {
    if (hintOptionRef.current) {
      setWithHint(hintOptionRef.current.selected);
    }
  }, [value, children]);
  const baseClass = `${prefix}select`;
  const classes = cx(
    `${baseClass}`,
    disabled && `${baseClass}--disabled`,
    ssrIcon && `${baseClass}--leading-icon`,
    `${prefix}label-wrapper ${prefix}label-wrapper--text-input`,
    withHint && `${baseClass}--hint`,
    className
  );
  return /* @__PURE__ */ jsxs("div", { className: classes, children: [
    label && /* @__PURE__ */ jsx(Label, { prefix, htmlFor: id, label, reqText: req }),
    /* @__PURE__ */ jsxs("div", { className: `${baseClass}__wrapper`, children: [
      /* @__PURE__ */ jsxs(
        "select",
        {
          value,
          ref: selectRef,
          id,
          disabled,
          onChange: handleOnChange,
          "aria-describedby": describedById,
          required,
          ...other,
          children: [
            hintText && /* @__PURE__ */ jsx("option", { disabled: required, value: "", ref: hintOptionRef, children: hintText }),
            children
          ]
        }
      ),
      ssrIcon && /* @__PURE__ */ jsx(
        SSRIcon,
        {
          className: `${baseClass}__icon`,
          paths: ssrIcon,
          prefix
        }
      ),
      /* @__PURE__ */ jsx(
        SSRIcon,
        {
          className: `${baseClass}__chevron-down`,
          prefix,
          paths: chevronDownSmall
        }
      ),
      /* @__PURE__ */ jsx(
        ValidationBorder,
        {
          prefix,
          shouldValidate,
          valid,
          disabled
        }
      )
    ] })
  ] });
};
var Select_default = Select;
export {
  Select_default as default
};
